import React from 'react';
import bemCn from 'bem-cn';
import CookieService from '../../services/cookie.service';
import { RouteFormatter } from '../../routes';
import { COOKIE_PARAM_NAME } from '../../consts/cookies.consts';
import SniffButton from '../sniff-button';
import './style.scss';

const b = bemCn('request-more-photos');

const RequestMorePhotos = ({ id }) => {
    const handleReq = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const path = RouteFormatter.listings({ first: id });
        CookieService.set(COOKIE_PARAM_NAME.REDIRECT, path, { expires: 1 });
        CookieService.set(COOKIE_PARAM_NAME.SIGN_UP_FROM, 'PHOTO_REQUEST_WEB', { expires: 1 });
        window.location = RouteFormatter.signUp();
    };

    return (
        <div className={b()}>
            <p className="snif-p snif-semibold text-center mb-3">
                Want to see more details?
                <br />
                Let the host know!
            </p>
            <div className="text-center">
                <SniffButton color="secondary" size="lg" onClick={handleReq}>
                    Request more photos
                </SniffButton>
            </div>
        </div>
    );
};

export default RequestMorePhotos;
